// user avatar colors
export const AVATAR_COLORS = [
  '9FA8DA',
  '80CBC4',
  '90CAF9',
  'A5d6A7',
  'B39DDB',
  'CE93D8',
  'EF9A9A',
  'F48FB1',
  'FFAB91',
  'FFCC80',
];

interface ProgressColor {
  left: string
  right: string
  unfilled: Record<string, string>
};

const UNFILLED_PROGRESS_COLOR: Record<string, string> = {
  'light': '#F0F0F5',
  'dark': '#32324E'
}

export const BASIC_STATS_PROGRESS_COLORS: Record<string, ProgressColor> = {
  'problems_solved': {
    left: '#2952A3',
    right: '#00C5FB',
    unfilled: UNFILLED_PROGRESS_COLOR
  },
  'problems_sets_completed': {
    left: '#73009A',
    right: '#9290F8',
    unfilled: UNFILLED_PROGRESS_COLOR
  },
};

export const DIFFICULTY_STATS_PROGRESS_COLORS: Record<string, ProgressColor> = {
  'beginner_problems_solved': {
    left: '#239023',
    right: '#4DFFB8',
    unfilled: UNFILLED_PROGRESS_COLOR
  },
  'intermediate_problems_solved': {
    left: '#E6B800',
    right: '#FFFF33',
    unfilled: UNFILLED_PROGRESS_COLOR
  },
  'advanced_problems_solved': {
    left: '#B32D00',
    right: '#FF3333',
    unfilled: UNFILLED_PROGRESS_COLOR
  }
}
